import { render, staticRenderFns } from "./Drone.vue?vue&type=template&id=bcb7e0da&scoped=true&"
import script from "./Drone.vue?vue&type=script&lang=js&"
export * from "./Drone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb7e0da",
  null
  
)

export default component.exports